import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetOffersFromRecommendedApiFailed, EGetOffersFromRecommendedApiActionType } from './types';

export const getOffersFromRecommendedApiFailed: () => TGetOffersFromRecommendedApiFailed =
  actionGenerator<EGetOffersFromRecommendedApiActionType.Failed>(EGetOffersFromRecommendedApiActionType.Failed);
